import React from 'react';
import { MessageCircle } from 'lucide-react';
import { BRAND } from '../../data/mock';

const WhatsAppFloat = () => {
  const handleWhatsAppClick = () => {
    window.open(
      `https://wa.me/${BRAND.whatsapp}?text=Hi! I'm interested in Inkfly Photo Booth services.`,
      '_blank'
    );
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white" fill="white" />
    </button>
  );
};

export default WhatsAppFloat;
